import React from "react";
import "./footer.css";
import logo from "../../res/logo.png";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <img src={logo} alt="Logo" className="footer__logo" />
      <span className="footer__brand-name">ElMeta.cl</span>
      <div className="footer__social">
        <a
          href="https://www.instagram.com/elmetacl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="footer__icon" />
        </a>
        <a
          href="https://www.tiktok.com/@elmetacl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTiktok className="footer__icon" />
        </a>
      </div>
      <p className="footer__legal-text">
        Aviso Legal: El contenido literal y gráfico presentado en este sitio
        sobre Mitos y Leyendas —incluyendo imágenes de cartas, textos, diseños y
        material relacionado—, así como el juego de cartas Mitos y Leyendas y
        sus marcas registradas, son propiedad de ©Fénix Entertainment S.P.A.
        Este sitio web no está producido, avalado, respaldado ni afiliado con
        Fénix Entertainment S.P.A. ni con sus licenciatarios oficiales. Mitos y
        Leyendas es un juego registrado y protegido por las leyes de propiedad
        intelectual.
      </p>
    </footer>
  );
};

export default Footer;
